export const REASSIGN_DEVICE_MODAL_FORM = 'REASSIGN_DEVICE_MODAL_FORM'
